import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ScrapCategoryDto {
  id: string;
  name: string;
  image: string;
}

export interface CreateScrapCategoryDto {
  name: string;
  image?: string;
  isScrap: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ScrapCategoryService {
  private readonly baseUrl = `${environment.apiConfig.uri}/api/ScrapCategory`;

  constructor(private http: HttpClient) {}

  getScrapCategories(): Observable<ScrapCategoryDto[]> {
    return this.http.get<ScrapCategoryDto[]>(this.baseUrl);
  }

  createScrapCategory(dto: CreateScrapCategoryDto): Observable<ScrapCategoryDto> {
    return this.http.post<ScrapCategoryDto>(`${this.baseUrl}/create`, dto);
  }
}
